<div class="snackbar-wrapper" [ngClass]="data.status">
    <div class="snackbar-content">
        <mat-icon class="status-icon">{{ getIcon(data.status) }}</mat-icon>
        <span class="message">{{ data.message | translate: data.params }}</span>
    </div>
    @if (data.action) {
        <button type="button" class="snackbar-action" (click)="act()">{{ data.action | translate }}</button>
    }
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</div>
